import AccettazioneSsn from "../";

const routes = [
    { name: "Elenco Accettazione Ssn", path: "/accettazionessn", component: AccettazioneSsn.AccettazioneSsnListPage, meta: { title: "Elenco Accettazioni" } },
    { name: "Accettazione Ssn Dettaglio", path: "/accettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPage, meta: { title: "Crea/Modifica Accettazione" } },
    { name: "Prenotazioni Lazio Recup", path: "/prenotazionilaziorecup", component: AccettazioneSsn.AccettazionePrenotazioniLazioListPage, meta: { title: "Elenco Prenotazione Recup" } },
    { name: "Elenco Ricette Prestazioni", path: "/accettazioneprestazioniappuntamenti", component: AccettazioneSsn.AccettazioneRicettaPrestazioniListaPage, meta: { title: "Elenco Appuntamenti Ricette" } },
    { name: "Appuntamenti Accettazione", path: "/accettazioneappuntamenti", component: AccettazioneSsn.AccettazionePrestazioniListPage, meta: { title: "Elenco Appuntamenti Ricette" } },


];

export default routes;
